import { Component, OnInit } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { ActivatedRoute, Router } from '@angular/router';
import { TagsService } from '../tags.service';
import { TypesService } from '../../type/types.service';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.css']
})
export class TagComponent implements OnInit {
  tagForm: DVFormGroup;
  isAddState = true;
  groups : [];
  constructor(
    private typeApi: TypesService,
    private tagApi: TagsService,
    private notifier: SnotifyService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.typeApi.getTypes().subscribe(response => {
      console.log(response, 'sssssssss');
      this.groups = response.data.tagGroups.map(r => {
        return {
          id: r.id,
          name: r.name,
        }
      });
    });
    if (this.route.snapshot.params[`id`]) {
      this.isAddState = false;
      this.tagApi.getTagById(this.route.snapshot.params.id).subscribe((Response)=>{
        console.log(Response.data);
        this.tagForm.patchValue(Response.data.tag);
      });
    } else {
      this.isAddState = true;
    }
    this.tagForm = new DVFormGroup({
      name: new DVFormControl(null, {
        'Name is required': Validators.required
      }),
      groupId: new DVFormControl(null, {
        'Group is required': Validators.required
      })
    });
  }

  ngOnInit() {}
  SubmitForm() {
    if (this.tagForm.valid) {
      console.log('Content', this.tagForm.value);
      this.tagApi.addTag(this.tagForm.value).subscribe(Response => {
        // console.log(Response);
        this.notifier.success('Tag Has Added Successfully');
        this.router.navigateByUrl('/filters/tag/list');
        this.tagForm.reset();
      });
    } else {
      this.tagForm.forceShowErrors();
    }
  }
  EditForm() {
    if (this.tagForm.valid) {
    this.tagForm.value.id = this.route.snapshot.params.id;
    this.tagApi.editTag(this.tagForm.value, this.route.snapshot.params.id).subscribe((Response) => {
      console.log(Response);
      this.notifier.success('Tag Edited Successfully');
      this.router.navigateByUrl('/filters/tag/list');
    }, err => {
      this.notifier.error(err.error.userMessage);
    });
   } else {
    this.tagForm.forceShowErrors();
  }
  }
  CancelForm() {
    this.router.navigateByUrl('/filters/tag/add');
  }
}
